import { ConsentsForm } from 'components/authentication/ConsentsForm';
import React, { Dispatch } from 'react';
import { connect } from 'react-redux';
import { IConsent, ISignInSignUpWithEmailVariables } from 'store/sagas/apiService/types';
import { RootAction, State } from 'store/state';
import { signInSignUpWithEmail } from 'store/state/app/actions';
import { authEmailSelector } from 'store/state/app/selectors';

const TermsBase: React.FC<{ onSignInSignUpWithEmail: (data: ISignInSignUpWithEmailVariables) => void; email: string }> = ({ onSignInSignUpWithEmail, email }) => {
  const handleSignInSignUpWithConsentsSubmit = (consents?: IConsent[]) => {
    onSignInSignUpWithEmail({ email: email.toLowerCase(), consents });
  };

  return <ConsentsForm handleSubmit={handleSignInSignUpWithConsentsSubmit} />;
};

const mapStateToProps = (state: State) => ({
  email: authEmailSelector(state),
});

const mapDispatchToProps = (dispatch: Dispatch<RootAction>) => ({
  onSignInSignUpWithEmail: (data: ISignInSignUpWithEmailVariables) => dispatch(signInSignUpWithEmail(data)),
});

export const Terms = connect(mapStateToProps, mapDispatchToProps)(TermsBase);
